import React from "react"
import ReactMarkdown from "react-markdown"
import { useLoaderData } from "react-router-dom"
import breaks from "remark-breaks"

import * as S from "./style"
import Title from "../../components/Title"
import { useScrollToOnChange } from "../../helpers"
import PageTemplate from "../PageTemplate"

export const Component = () => {
  const { title, content, content2 } = useLoaderData()

  useScrollToOnChange(content)

  return (
    <PageTemplate>
      <S.PolicyContainer>
        <Title>{title}</Title>
        <div>
          <ReactMarkdown remarkPlugins={[breaks]}>{content}</ReactMarkdown>
        </div>
        {content2 && (
          <div>
            <ReactMarkdown remarkPlugins={[breaks]}>{content2}</ReactMarkdown>
          </div>
        )}
      </S.PolicyContainer>
    </PageTemplate>
  )
}
